import { toast } from "sonner";

import { TimeAPI } from "../api/timeApi";
import { refreshTime } from "../queries";
import { useTrackerStore } from "./trackerStore";

/** Pause or resume in-app capture now, and put it back if the save fails. */
export const setTrackingPaused = (next: boolean): void => {
  useTrackerStore.getState().setPaused(next);
  TimeAPI.saveMySettings({ paused: next }).then(refreshTime, () => {
    useTrackerStore.getState().setPaused(!next);
    toast.error(next ? "Couldn't pause tracking" : "Couldn't resume tracking");
  });
};
